import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { http } from "@bridewell/api-client";
import { Button } from "@/components/ui/button";
import { AuthLayout } from "@/features/auth/auth-layout";
import { noindexHead } from "@/features/marketing/seo";
import { t } from "@/i18n";

/**
 * Where the opt-out link in a guest email lands (a guest, not a Bridewell user: no session, nothing stored, no cookie
 * notice — a token page). Opening the link changes nothing (mail scanners open links); the button posts once.
 */
export const Route = createFileRoute("/mail-opt-out")({
  validateSearch: (s: Record<string, unknown>) => ({ t: typeof s.t === "string" ? s.t : "" }),
  head: () => noindexHead(t("marketing.seo.mailOptOut")),
  component: MailOptOut,
});

function MailOptOut() {
  const { t: token } = Route.useSearch();
  const m = useMutation({ mutationFn: async () => (await http.post<{ coupleTitle: string | null }>(`/guest-mail/opt-out?t=${encodeURIComponent(token)}`)).data });
  return (
    <AuthLayout title={t("guestMail.optOutTitle")}>
      {m.isSuccess ? (
        <p className="text-[15px]">{m.data.coupleTitle ? t("guestMail.optOutDone", { couple: m.data.coupleTitle }) : t("guestMail.optOutDoneNoName")}</p>
      ) : m.isError || !token ? (
        <p className="text-[15px] text-text-secondary">{t("guestMail.optOutInvalid")}</p>
      ) : (
        <div className="flex flex-col gap-4">
          <p className="text-[15px] text-text-secondary">{t("guestMail.optOutBody")}</p>
          <Button loading={m.isPending} onClick={() => m.mutate()}>{t("guestMail.optOutButton")}</Button>
        </div>
      )}
    </AuthLayout>
  );
}
